var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-graphic"},[_c('Title',{attrs:{"top":_vm.newData.title.top,"name":_vm.newData.title.name}}),_c('Legenda',{attrs:{"legendas":_vm.data.legenda}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }